import React from "react";
import { Loader2, MessageSquare } from "lucide-react";
import { useThreadList } from "../../hooks/queries/useDirectMessages";

const formatRelativeTime = (iso) => {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "ahora";
  if (mins < 60) return `${mins}m`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;
  return new Date(iso).toLocaleDateString("es-ES", { day: "numeric", month: "short" });
};

const ThreadList = ({ onSelectThread, selectedId }) => {
  const threadsQuery = useThreadList();
  const threads = threadsQuery.data || [];

  if (threadsQuery.isLoading) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 size={24} className="animate-spin text-blue-500" />
      </div>
    );
  }

  if (threads.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
        <MessageSquare size={40} className="mb-3 text-gray-300" />
        <p className="font-medium text-gray-500">No tienes conversaciones</p>
        <p className="mt-1 text-sm text-gray-400">
          Las conversaciones se abren cuando un scout y un atleta conectan.
        </p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-100">
      {threads.map((thread) => {
        const crId = thread.contact_request_id;
        const name = thread.other_party?.full_name || "Usuario";
        const org = thread.other_party?.organization_name;
        const preview = thread.latest_message?.body || thread.request?.message || "";
        const time = thread.latest_message?.created_at || thread.request?.created_at;
        const unread = thread.unread_count > 0;
        const isSelected = selectedId === crId;

        return (
          <button
            key={crId}
            type="button"
            onClick={() => onSelectThread(thread)}
            className={`flex w-full items-start gap-3 px-4 py-3 text-left transition-colors ${
              isSelected ? "bg-blue-50" : "hover:bg-gray-50"
            }`}
          >
            <div className="grid h-10 w-10 flex-shrink-0 place-items-center rounded-full bg-blue-100 text-blue-700">
              <span className="text-sm font-bold">
                {name.charAt(0).toUpperCase()}
              </span>
            </div>

            <div className="min-w-0 flex-1">
              <div className="flex items-baseline justify-between gap-2">
                <span
                  className={`truncate text-sm ${
                    unread ? "font-bold text-gray-900" : "font-medium text-gray-800"
                  }`}
                >
                  {name}
                </span>
                <span className="flex-shrink-0 text-[11px] text-gray-400">
                  {formatRelativeTime(time)}
                </span>
              </div>
              {org && (
                <p className="truncate text-xs text-gray-500">{org}</p>
              )}
              <div className="mt-0.5 flex items-center gap-2">
                <p
                  className={`min-w-0 flex-1 truncate text-sm ${
                    unread ? "font-medium text-gray-700" : "text-gray-500"
                  }`}
                >
                  {preview}
                </p>
                {unread && (
                  <span className="inline-flex h-5 min-w-[20px] flex-shrink-0 items-center justify-center rounded-full bg-blue-600 px-1.5 text-[11px] font-bold text-white">
                    {thread.unread_count > 9 ? "9+" : thread.unread_count}
                  </span>
                )}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ThreadList;
